<template>
  <!-- 退款审核 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
          >
            <template slot="batch-search-btn">
              <el-button
                type="primary"
                :size="formSize"
                :loading="loading"
                @click="handleBatchSearch()"
              >
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <jr-select
            title="退款审核状态"
            v-model="queryForm.approvalStatus"
            :size="formSize"
            @change="refreshList"
            dictionary-type="APPROVAL_STATUS"
          />
          <div class="fan-search-col fan-search-right">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              :recommendedColumn="recommendedColumn"
              @confirm="handleConfirm"
            />
            <template v-if="$has('FWS-KJSH-SKTK-TGBH')">
              <el-button
                type="success"
                icon="el-icon-success"
                :size="formSize"
                :disabled="!multipleSelection || multipleSelection.length === 0"
                @click="handleBatchOperateState(1)"
              >
                批量通过
              </el-button>
              <el-button
                type="danger"
                icon="el-icon-delete-solid"
                :size="formSize"
                :disabled="!multipleSelection || multipleSelection.length === 0"
                @click="handleBatchOperateState(2)"
              >
                批量驳回
              </el-button>
            </template>
            <div style="margin-left: 10px" v-if="$has('FWS-KJSH-SKTK-DC')">
              <export-button
                title="收款退款审核数据导出"
                button-text="导出"
                :requestUrl="requestUrl"
                :post-params="exportParams"
                :total="total"
                :isLimit="true"
              />
            </div>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          @selection-change="handleSelectionChange"
          ref="refundListRef"
        >
          <template v-slot:options="{row}">
            <btns-operate
              :current="row"
              @success="handleOperateStateResults"
            />
          </template>
        </jr-table>
      </template>

      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 确认/取消确认弹窗 -->
    <operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="refundObj"
      :text-config.sync="textConfig"
      :totalInfo.sync="totalInfo"
      :loading="submitLoading"
      @submit="setRefundApproval"
    />
    <!-- 详情 -->
    <detail
      :visible.sync="isDetailShow"
      :refund-no.sync="refundNo"
      @after-done="getList"
    />
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :searchType="queryForm.searchType"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
    />
  </div>
</template>

<script>
import { getRefundList, EXPORT_REFUND } from '@/api/approval/refund';
import { add } from 'mathjs';
import detail from './components/detail';
import refundMixins from './mixins/refund';
import { setStatusColor } from '@/filters/index';
import btnsOperate from './components/btns-operate';

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  searchContent: '', // 搜索值
  searchType: '2',
  approvalStatus: '', // 审核状态 1 待审核 2 已通过 -1 已驳回 -2 已取消 0 取消中
  transType: 2, // 订单交易类型1=自营2=服务商
  timeType: '1',
};

export default {
  name: 'ApprovalRefundList',
  components: { detail, btnsOperate },
  mixins: [refundMixins],
  data() {
    const list = [
      {
        value: '1',
        label: '退款申请单编号',
      }, {
        value: '2',
        label: '业务订单编号',
      }, {
        value: '3',
        label: '收款退款单编号',
      },
      // {
      //   value: '4',
      //   label: '应收单编号',
      // },
      {
        value: '5',
        label: '采购商编号',
      },
    ];
    return {
      requestUrl: EXPORT_REFUND,
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
            { label: '审核时间', value: '2' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [
            ...list,
            {
              value: '6',
              label: '采购商名称',
            },
          ],
        },
      ],
      batchSearchTypeList: [ // 批量搜索搜索条件集合
        ...list,
      ],
      isDetailShow: false, // 详情弹窗
      refundNo: '', // 退款审核编号
      /** ------批量搜索---- */
      isBatchSearchShow: false, // 批量搜索
      isBatch: false, // 是否批量操作
      batchResults: {}, // 批量操作返回结果
      /** ------批量操作---- */
      multipleSelection: [], // 选中的数据
      // 批量操作合并信息
      totalInfo: {
        totalNum: 0, // 合计数量
        totalAmount: 0, // 合计金额
      },
      tableColumn: [
        {
          type: 'selection',
          width: '40',
          align: 'center',
          isShow: () => false,
          show: () => this.$has('FWS-KJSH-SKTK-TGBH'),
          selectable: (row) => this.setDisabled(row),
        },
        {
          prop: 'refundNo',
          label: '收款退款单编号',
          minWidth: '1',
          disabled: true,
          click: (row) => this.handleDetail(row),
          show: () => this.$has('FWS-KJSH-SKTK-XQ'),
        },
        { prop: 'refundApplyNo', label: '退款申请编号', minWidth: '1' },
        { prop: 'orderNumber', label: '业务订单编号', minWidth: '1' },
        { prop: 'businessNo', label: '采购商编号', minWidth: '1' },
        { prop: 'businessName', label: '采购商', minWidth: '1' },
        { prop: 'payeeBusinessName', label: '服务商名称', minWidth: '1' },
        { prop: 'refundAmount', label: '申请退款金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'shouldRecAmount', label: '应收总额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'realAmount', label: '实收金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'refundReason', label: '退款原因', minWidth: '1', showOverflowTooltip: true },
        { prop: 'crtime', label: '创建时间', minWidth: '1', filterName: 'formatTime' },
        {
          label: '审核状态',
          prop: 'approvalStatus',
          status: 'approvalStatus',
          statusDesc: 'approvalStatusDesc',
          statusColor: (val) => setStatusColor(val, 'approvalStatus'),
        },
        { prop: 'approvalUser', label: '操作人', minWidth: '1' },
        { prop: 'operate', slotName: 'options', label: '操作', width: '110', disabled: true },
      ],
      columnsKey: 'fwsRefundList',
      selectTableColumn: [],
      recommendedColumn: [
        { prop: 'approvalTime', label: '审核时间', minWidth: '1', filterName: 'formatTime' },
        { prop: 'rejectReason', label: '驳回原因', minWidth: '1', showOverflowTooltip: true },
        { prop: 'bdName', label: 'BD', minWidth: '1' },
      ],
    };
  },
  computed: {
    exportParams() {
      const params = {
        ...this.queryForm,
      };
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const { approvalStatus } = this.$route.query;
      this.queryForm.approvalStatus = approvalStatus || '';
      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
          recommendedColumn: this.recommendedColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.refundListRef.doLayout();
      });
    },
    // 多选选择返回结果
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量确认多选限制设置
    setDisabled(row) {
      if ([1, '1'].includes(row.approvalStatus)) {
        return 1;
      }
      return 0;
    },
    // 批量确认操作
    handleBatchOperateState(operation) {
      const refundNos = (this.multipleSelection || []).map((item) => item.refundNo);
      this.refundObj = {
        refundNos: refundNos ? (refundNos || []).join(',') : '',
        operation, // 操作：1、通过 2、驳回
        cancelRemark: '', // 驳回原因，驳回时必传
      };
      const list = {
        1: {
          title: '批量审核通过确认',
          messageTip: '是否批量审核通过所有被选中的退款申请？',
          isPass: true,
          isBatch: true,
          isTotal: true,
        },
        2: {
          title: '批量审核驳回',
          messageTip: '批量驳回原因',
          isPass: false,
          isBatch: true,
          isTotal: true,
          required: true,
        },
      };
      this.textConfig = list[operation] || '-';
      this.totalInfo = {
        totalNum: this.multipleSelection.length || 0, // 合计数量
        totalAmount: (this.multipleSelection.map((item) => item.refundAmount || 0) || []).reduce((prev, cur) => {
          return add(prev, cur);
        }), // 合计金额
      };
      this.isOperateStateShow = true;
    },
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      this.batchResults = form;
      const param = { ...queryFormDefault };
      param.searchType = form.searchType || '';
      param.searchContent = (form.list || []).join(',');
      this.queryForm = { ...param };
      this.getRefundList(param, true);
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 退款审核确认/取消确认操作返回结果
    handleOperateStateResults() {
      if (this.isBatch) {
        this.handleBatchSearchConfirm(this.batchResults, true);
      } else {
        this.getList();
      }
    },
    // 详情
    handleDetail(row) {
      this.refundNo = row?.refundNo || '';
      this.isDetailShow = true;
    },

    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    setQuery(params) {
      this.queryForm = { ...this.queryForm, ...params };
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = {
        ...this.queryForm,
        ...params,
        page: 1,
      };
      this.getList();
    },
    // 列表查询
    getList() {
      this.getRefundList(this.queryForm);
    },
    // 列表接口请求
    async getRefundList(param, isBatch = false) {
      try {
        this.isBatch = isBatch;
        this.loading = true;
        this.list = [];
        const res = await getRefundList(param);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
  },
};
</script>

<style lang="scss">
</style>
